import { render, staticRenderFns } from "./DashboardStatFigure.vue?vue&type=template&id=4910b488&scoped=true&"
import script from "./DashboardStatFigure.vue?vue&type=script&lang=js&"
export * from "./DashboardStatFigure.vue?vue&type=script&lang=js&"
import style0 from "./DashboardStatFigure.vue?vue&type=style&index=0&id=4910b488&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4910b488",
  null
  
)

export default component.exports